import React, { memo, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'b2b-ui-components-lib/lib/components/accordion';

import { numberWithCommas } from 'home/view/upgrade-order/utils';
import { getSummaryProductDisplayName } from 'common/constants/app.constants';

const TitleComponent = memo(({ isExpanded = false, circuitId = '', productName = '', currentBw = '', arc = '' }) => {
  return isExpanded ? (
    <div className="upgrade-header-open">
      <div className="title pad-bottom-0">Existing Site Details</div>
      <label className="field_label">The following are the details for the existing site.</label>
    </div>
  ) : (
    <Fragment>
      <div className="upgrade-header-open">
        <div className="title pad-bottom-0">Existing Site Details</div>
        <label className="field_label">The following are the details for the existing site.</label>
      </div>
      <ul className="upgrade-header-closed">
        {circuitId ? <li key={circuitId}>{`Circuit ID: ${circuitId} (Active Network)`}</li> : null}
        {productName ? <li key={productName}>{`Product Name: ${productName}`}</li> : null}
        {currentBw ? <li key={currentBw}>{`Current Bandwidth: ${currentBw}`}</li> : null}
        {arc ? <li key={arc}>{`Annual Recurring Charge: ₹ ${arc}`}</li> : null}
      </ul>
    </Fragment>
  );
});

const ExistingDetailsAccordionSummary = ({ orderDetail }) => {
  const [accordionMeta, setAccordionMeta] = useState({
    isExpanded: true
  });

  const defaultExistingDetails = {
    circuitId: orderDetail?.lead?.connectivityLineItems?.[0]?.lsiId || '-',
    productName: getSummaryProductDisplayName(orderDetail?.lead?.connectivityLineItems?.[0]?.serviceType) || '-',
    currentBw: orderDetail?.lead?.connectivityLineItems?.[0]?.oldLineItemDetail?.bandwidth || '-',
    companyName: orderDetail?.companyAddress?.officeName?.toTitleCase() || '-',
    companyAddress: orderDetail?.companyAddress?.addressLine1?.toTitleCase() || '-',
    mediaType: orderDetail?.lead?.connectivityLineItems?.[0]?.selectedMedia?.[0]?.media || '-',
    installationAddress: orderDetail?.lead?.connectivityLineItems?.[0]?.oldLineItemDetail?.address?.line1?.toTitleCase() || '-',
    serviceType: `${orderDetail?.lead?.connectivityLineItems?.[0]?.oldLineItemDetail?.subProductName?.toTitleCase()} Service` || '-',
    annualRecurringCharge: numberWithCommas(orderDetail?.lead?.connectivityLineItems?.[0]?.oldLineItemDetail?.price?.rental)
  };

  return (
    <div className="existing-details upgrade-accordion">
      <Accordion
        autoScrollOnExpand={false}
        title={
          <TitleComponent
            isExpanded={accordionMeta.isExpanded}
            circuitId={defaultExistingDetails.circuitId}
            productName={defaultExistingDetails.productName}
            currentBw={defaultExistingDetails.currentBw}
            arc={defaultExistingDetails.annualRecurringCharge}
          />
        }
        isExpanded={accordionMeta.isExpanded}
        onExpandClick={() =>
          setAccordionMeta((accordionMeta) => ({
            ...accordionMeta,
            isExpanded: !accordionMeta.isExpanded
          }))
        }
        variant="round"
      >
        <div className="upgrade-body">
          <div className="row">
            {defaultExistingDetails.circuitId ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Circuit ID</label>
                    <div className="value">{`${defaultExistingDetails.circuitId} (Active Network)`}</div>
                  </div>
                </div>
              </div>
            ) : null}
            {defaultExistingDetails.productName ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Product Name</label>
                    <div className="value">{defaultExistingDetails.productName}</div>
                  </div>
                </div>
              </div>
            ) : null}
            {defaultExistingDetails.currentBw ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Current Bandwidth</label>
                    <div className="value">{defaultExistingDetails.currentBw}</div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="row">
            {defaultExistingDetails.mediaType ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Media Type</label>
                    <div className="value">{defaultExistingDetails.mediaType}</div>
                  </div>
                </div>
              </div>
            ) : null}
            {defaultExistingDetails.serviceType ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Service Type</label>
                    <div className="value">{defaultExistingDetails.serviceType}</div>
                  </div>
                </div>
              </div>
            ) : null}
            {defaultExistingDetails.annualRecurringCharge ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Annual Recurring Charge</label>
                    <div className="value">&#8377; {defaultExistingDetails.annualRecurringCharge}</div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="row">
            {defaultExistingDetails.installationAddress ? (
              <div className="flg-lg-4 flg-md-6 flg-sm-12">
                <div className="control_group">
                  <div className="prefield_details">
                    <label className="field_label">Installation Address</label>
                    <div className="value">{defaultExistingDetails.installationAddress}</div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </Accordion>
    </div>
  );
};

ExistingDetailsAccordionSummary.propTypes = {
  leadData: PropTypes.object.isRequired
};

export default memo(ExistingDetailsAccordionSummary);
